import { useEffect, useRef, useState } from "react";
import "./Banners.css";

const API_URL = "https://api.mariamlyluxe.com/public/api/banners"; // adjust in prod

export default function Banners() {
  const [banners, setBanners] = useState([]);
  const [idx, setIdx] = useState(0);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const timerRef = useRef(null);

  // Fetch banners
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(API_URL, { headers: { Accept: "application/json" } });
        const json = await res.json();
        if (!cancelled) {
          const list = Array.isArray(json?.data) ? json.data : [];
          setBanners(list);
          setLoading(false);
        }
      } catch (e) {
        if (!cancelled) {
          setErr("Failed to load banners");
          setLoading(false);
        }
      }
    })();
    return () => { cancelled = true; };
  }, []);

  // Autoplay
  useEffect(() => {
    if (!banners.length) return;
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setIdx((i) => (i + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timerRef.current);
  }, [banners]);

  const go = (to) => {
    if (!banners.length) return;
    setIdx((prev) => {
      if (to === "prev") return (prev - 1 + banners.length) % banners.length;
      if (to === "next") return (prev + 1) % banners.length;
      return to;
    });
  };

  if (loading) {
    return (
      <div className="bnr-wrap">
        <div className="bnr-skeleton" />
      </div>
    );
  }
  if (err || !banners.length) return null;

  return (
    <section className="bnr-wrap" aria-label="Promotional banners">
      <div className="bnr-viewport">
        <div
          className="bnr-track"
          style={{ transform: `translateX(-${idx * 100}%)` }}
        >
          {banners.map((b, i) => {
            const isVideo = b.is_video || b.media_type === "video";
            const mediaUrl = b.image_url;
            
            return (
              <a
                className="bnr-slide"
                key={b.id ?? i}
                href="#"
                aria-label={`Banner ${i + 1}`}
              >
                {isVideo ? (
                  <video
                    src={mediaUrl}
                    autoPlay
                    muted
                    loop
                    playsInline
                    loading={i === 0 ? "eager" : "lazy"}
                  />
                ) : (
                  <img
                    src={mediaUrl}
                    alt={`Banner ${i + 1}`}
                    loading={i === 0 ? "eager" : "lazy"}
                    decoding="async"
                  />
                )}
              </a>
            );
          })}
        </div>

        {/* Arrows */}
        <button className="bnr-arrow left" onClick={() => go("prev")} aria-label="Previous slide">
          ‹
        </button>
        <button className="bnr-arrow right" onClick={() => go("next")} aria-label="Next slide">
          ›
        </button>

        {/* Dots */}
        <div className="bnr-dots" role="tablist" aria-label="Select banner">
          {banners.map((_, i) => (
            <button
              key={i}
              className={`bnr-dot ${i === idx ? "active" : ""}`}
              onClick={() => go(i)}
              role="tab"
              aria-selected={i === idx}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
